import User from "./User";

export default class UserStatus {
    
    public user: User = new User();
    
    public completed: boolean = false;

    public isUserStatus: boolean = true;
}